  (function () {
    const roots = document.querySelectorAll('[data-embroidery-gallery]');
    if (!roots.length) return;

    roots.forEach((root) => {
      const overlay = root.querySelector('[data-overlay]');
      const modals = Array.from(root.querySelectorAll('[data-modal]'));

      let activeModal = null;
      let activeOpener = null;

      function hideAll() {
        modals.forEach((m) => (m.hidden = true));
      }

      function lockScroll(lock) {
        document.documentElement.style.overflow = lock ? 'hidden' : '';
      }

      function openModalById(id, opener) {
        const modal = root.querySelector('[data-modal="' + id + '"]');
        if (!modal) return;

        // Close anything else
        hideAll();

        overlay.hidden = false;
        modal.hidden = false;
        lockScroll(true);

        activeModal = modal;
        activeOpener = opener || null;

        if (activeOpener) activeOpener.setAttribute('aria-expanded', 'true');

        const closeBtn = modal.querySelector('[data-close]');
        if (closeBtn) closeBtn.focus();
      }

      function closeModal() {
        if (!activeModal) return;

        activeModal.hidden = true;
        overlay.hidden = true;
        lockScroll(false);

        if (activeOpener) {
          activeOpener.setAttribute('aria-expanded', 'false');
          activeOpener.focus();
        }

        activeModal = null;
        activeOpener = null;
      }

      // Ensure everything starts hidden (in case theme breaks [hidden])
      hideAll();
      overlay.hidden = true;

      // Open/close via event delegation
      root.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-open-modal]');
        if (openBtn && root.contains(openBtn)) {
          const id = openBtn.getAttribute('data-open-modal');
          openModalById(id, openBtn);
          return;
        }

        const closeBtn = e.target.closest('[data-close]');
        if (closeBtn && root.contains(closeBtn)) {
          closeModal();
          return;
        }

        const modalEl = e.target.closest('[data-modal]');
        if (modalEl && !e.target.closest('.mnl-eg__modal-inner')) {
          closeModal();
          return;
        }
      });

      // Click on overlay closes
      overlay.addEventListener('click', closeModal);

      // ESC closes
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeModal();
      });
    });
  })();
